import Lookup from 'src/componentes/select2';

const ClassificacaoRelatorioAcompanhamento = ({ ...rest }) => {
  return (
    <Lookup
      clearable
      labelKey="descricao"
      valueKey="id"
      url="/ClassificacaoRelatorioAcompanhamentoLookup"
      {...rest}
    />
  );
};

export default ClassificacaoRelatorioAcompanhamento;
